import { Pipe, PipeTransform, inject } from "@angular/core";
import { SelectionRepository } from "common/selection/state/selection.repository";
import { getIdKeyOfTypeId } from "common/selection/helper/selection-helper";
import TypedId = stages.core.TypedId;

@Pipe({
	name: "selectionStoreIsSelected",

	pure: false,
})
export class SelectionStoreIsSelectedPipe implements PipeTransform {
	private selectionRepository = inject(SelectionRepository);

	transform(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Remove this comment and fix warnings!
		item: any,
		storeIdentifier: string,
		isSelectAllActivated: boolean,
		_toggleCounter: number, // underscore needed to pass "never read lint warning" because we need it to trigger pipe run
		// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Remove this comment and fix warnings!
		idFnNew?: (item: any) => TypedId,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Remove this comment and fix warnings!
		isPreselectedFn?: (item: any) => boolean,
		showSelectedWhenAllChildrenSelected = true,
	): boolean {
		if (!item || !idFnNew) {
			return false;
		}
		const typedId = idFnNew(item);
		const entity = this.selectionRepository.getEntityCommon(getIdKeyOfTypeId(typedId), storeIdentifier);
		let isSelected = false;
		if (entity) {
			if (!entity.isSelected && showSelectedWhenAllChildrenSelected && !!entity.totalChildrenCount) {
				// TODO handle dynamic store??
				const selectedChildrenCount = this.selectionRepository.getSelectedChildrenCountFromCommon(entity);
				isSelected = selectedChildrenCount === entity.totalChildrenCount;
			} else {
				isSelected = entity.isSelected && !entity.indeterminate;
			}
			const isFullySelectable = entity.selectableChildrenCount === entity.totalChildrenCount;
			// TODO return entity?.isSelected should work but does not when checking indeterminate item
			return isSelected && isFullySelectable;
		}
		const isPreselected = isPreselectedFn ? isPreselectedFn(item) : false;
		return isPreselected && isSelectAllActivated;
	}
}
